import Checkbox from "@mui/material/Checkbox";
import TableCell from "@mui/material/TableCell";
import { makeStyles } from "@mui/styles";
import { Table } from "@tanstack/react-table";
import React from "react";

interface Props<T> {
    table: Table<T>;
}

const useStyles = makeStyles(() => ({
    headerCell: {
        margin: 0,
        overflow: "hidden",
        border: "1px solid #CCC",
        borderWidth: "0 0 1px 0",
        whiteSpace: "nowrap",
        padding: "0px 8px",
        backgroundColor: "#F6F8FA",
        width: "40px",
        textAlign: "center"
    }
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const QATableSelectionHeader: React.FC<Props<any>> = props => {
    const classes = useStyles();

    return (
        <TableCell
            className={classes.headerCell}>

            <Checkbox
                checked={props.table.getIsAllRowsSelected()}
                indeterminate={props.table.getIsSomeRowsSelected()}
                onChange={props.table.getToggleAllRowsSelectedHandler()}
                style={{
                    padding: 0,
                    color: "black"
                }} />

        </TableCell>
    );
};

export default QATableSelectionHeader;
